module.exports = __webpack_public_path__ + "static/img/atour-gold.3a9005bc.png";